import PtHeader from '@patsnap-biz/header';
import '@patsnap-biz/header/lib/style';
import { setLangValue } from '../utils/langUtils';
import { get } from 'lodash';
import { handleLogout } from '@patsnap-utils/passport';
import LogoPatSnap from '@patsnap-biz/header/src/logos/PatSnap.vue';
import { Site, SLD } from '@patsnap-utils/biz';
import { psAxios } from '@patsnap/common-ps-http';
import PtHeaderWidgetCaseTime from '@patsnap-biz/header-widget-case-time';
import '@patsnap-biz/header-widget-case-time/lib/style';
import { ACCOUNT_SERVICE_URI } from 'library-@/config/apiConfig';
import { generateHelpLink } from '@home/shared/utils/get-help-center-link';

export default {
    components: {
        PtHeader,
        LogoPatSnap,
        PtHeaderWidgetCaseTime,
    },
    data() {
        const caseTimeService = new PtHeaderWidgetCaseTime.Service();
        caseTimeService.axios = psAxios;
        caseTimeService.accountServiceUrl = ACCOUNT_SERVICE_URI;
        return {
            caseTimeService
        };
    },
    async created() {
        const vm = this;
        const { locales } = this.headerService;
        this.headerService.title = this.$t('history.title');
        this.headerService.locales = locales.map(({ active, ...rest }) => {
            return {
                ...rest,
                active: rest.key === this.$i18n.locale
            };
        });

        const helpCenterUrl = new Site({ sld: SLD.HELP, pathname: 'help' }).href;
        const region = get(this.headerService, 'account._info.site_region');
        let menu = null;
        if (region !== 'CN') {
            menu = [
                {
                    icon: 'SolidHelpCentre',
                    label: vm.$t('header.helpCenter'),
                    href: generateHelpLink(region.toLowerCase())
                },
                // {
                //     icon: 'SolidUsers',
                //     href: 'https://help.patsnap.com/hc/en-us/community/topics',
                //     label: vm.$t('snapBusiness.headerV2.growth.patsnapCommunity')
                // },
                {
                    icon: 'SolidConversation',
                    label: vm.$t('header.askForHelp'),
                    href: new Site({ sld: SLD.HELP, pathname: 'hc/en-us/requests/new' }).href
                },
                null,
                {
                    icon: 'Term',
                    href: 'https://www.patsnap.com/legal',
                    label: vm.$t('snapBusiness.headerV2.growth.terms')
                },
                {
                    icon: 'Privacy',
                    href: 'https://www.patsnap.com/legal/privacy-policy',
                    label: vm.$t('snapBusiness.headerV2.growth.policy')
                }
            ];
        } else {
            menu = [
                {
                    icon: 'SolidHelpCentre',
                    href: new Site({ sld: SLD.HELP, pathname: 'help' }).href,
                    label: vm.$t('header.helpCenter')
                },
                null,
                {
                    icon: 'Term',
                    href: 'https://www.zhihuiya.com/legal/terms',
                    label: vm.$t('snapBusiness.headerV2.growth.terms')
                },
                {
                    icon: 'Privacy',
                    href: 'https://www.zhihuiya.com/legal/privacy',
                    label: vm.$t('snapBusiness.headerV2.growth.policy')
                }
            ];
        }
        // 白标签隐藏logo
        if (this.headerService.whiteLabel) {
            this.headerService.logo = false;
        }
        this.headerService.right = ['slot:timer', {
            icon: 'HelpCenter',
            trigger: 'hover',
            href: helpCenterUrl,
            menu,
            tooltip: menu ? null : this.$t('header.help') // 因为没有引入snapbusiness所以写在了history里
        }];
        /* 注册切换语言函数 */
        this.headerService.beforeLocaleChange = function beforeLocaleChange(localeKey, done) {
            setLangValue(localeKey).then(() => {
                window.location.reload();
                done();
            });
        };
        /* 注册登出回调函数 */
        this.headerService.userCenterService.logoutHandler = async function logout(done, logoutHref) {
            handleLogout().then((data) => {
                const href = get(data, 'data.redirect_url', logoutHref);
                window.location.href = href;
            });
        };

        /* logo跳转链接 */
        this.headerService.logoHref = new Site({ sld: SLD.HOME }).href;
    }
};
